// Imports
import axios from 'axios'

// App Imports
import { API_URL } from '../../../../setup/config/env'

// Actions

// Save
export function save(settings) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'settingSave',
      params: settings
    })
  }
}

// set resume orders
export function setResumeOrder(resumeOrder) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'setResumeOrder',
      params: resumeOrder
    })
  }
}

export function updateSettings({ vendorId, requestObject }) {
  return dispatch => {
    return axios.post(`${API_URL}/api/setting/update`, {
      "vendorId": vendorId,
      requestObject
    })
  }
}


// Holiday Mutations
export function createHolidayCollection(params) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'createHolidayCollection',
      params
    })
  }
}

export function updateHolidayCollection(params) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'updateHolidayCollection',
      params
    })
  }
}

export function deleteHolidayCollection(params) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'deleteHolidayCollection',
      params
    })
  }
}

export function bulkUpdateHolidayCollections(params) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'bulkUpdateHolidayCollections',
      params
    })
  }
}
